"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioButton = _interopRequireDefault(require("../../RadioButton"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Selection = function Selection(props) {
  return function (data, _ref) {
    var key = _ref.key;
    var type = props.type,
        selectedRowKeys = props.selectedRowKeys,
        _onChange = props.onChange;
    var checked = selectedRowKeys.includes(key);
    var Select = type === 'checkbox' ? _Checkbox.default : _RadioButton.default;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row-selection"
    }, /*#__PURE__*/_react.default.createElement(Select, {
      label: "",
      checked: checked,
      onChange: function onChange() {
        return _onChange(key);
      }
    }));
  };
};

Selection.propTypes = {
  type: _propTypes.default.string.isRequired,
  selectedRowKeys: _propTypes.default.arrayOf(_propTypes.default.string),
  onChange: _propTypes.default.func
};
Selection.defaultProps = {
  selectedRowKeys: [],
  onChange: function onChange() {}
};
var _default = Selection;
exports.default = _default;